export enum ShareEmailOptions {
  BY_EMAIL = 'With Specific User',
  WHOLE_ORG = 'With Whole Org',
}
